const CACHE_TTL_MS = 5 * 60 * 1000;
const CACHE_MAX_ITEMS = 30;

const cache = new Map();
const pendingRequests = new Map();

const cloneValue = (value) => JSON.parse(JSON.stringify(value));

const normalizeCacheKey = (id) => {
  if (id === null || id === undefined || id === "") return null;
  return `${id}`;
};

const isExpired = (entry) => !entry || Date.now() - entry.cachedAt > CACHE_TTL_MS;

const pruneExpiredEntries = () => {
  for (const [key, entry] of cache.entries()) {
    if (isExpired(entry)) {
      cache.delete(key);
    }
  }
};

const touchEntry = (key, entry) => {
  cache.delete(key);
  cache.set(key, entry);
};

const pruneOverflow = () => {
  while (cache.size > CACHE_MAX_ITEMS) {
    const oldestKey = cache.keys().next().value;
    if (!oldestKey) return;
    cache.delete(oldestKey);
  }
};

export const getCachedSifcopDetail = (id) => {
  const key = normalizeCacheKey(id);
  if (!key) return null;

  pruneExpiredEntries();

  const entry = cache.get(key);
  if (!entry) return null;

  touchEntry(key, entry);
  return cloneValue(entry.doc);
};

export const setCachedSifcopDetail = (id, doc) => {
  const key = normalizeCacheKey(id);
  if (!key || !doc) return;

  pruneExpiredEntries();

  cache.set(key, {
    doc: cloneValue(doc),
    cachedAt: Date.now(),
  });

  pruneOverflow();
};

export const invalidateSifcopDetailCache = (id) => {
  const key = normalizeCacheKey(id);
  if (!key) return;

  cache.delete(key);
  pendingRequests.delete(key);
};

export const getOrFetchSifcopDetail = async (id, fetcher) => {
  const key = normalizeCacheKey(id);
  if (!key) return null;

  const cachedDoc = getCachedSifcopDetail(key);
  if (cachedDoc) return cachedDoc;

  if (pendingRequests.has(key)) {
    return pendingRequests.get(key);
  }

  const requestPromise = (async () => {
    const doc = await fetcher(id);

    if (!doc) {
      throw new Error("No se encontró el formulario SIFCOP.");
    }

    setCachedSifcopDetail(key, doc);
    return cloneValue(doc);
  })().finally(() => {
    pendingRequests.delete(key);
  });

  pendingRequests.set(key, requestPromise);
  return requestPromise;
};

export const prefetchSifcopDetail = async (id, fetcher) => {
  try {
    await getOrFetchSifcopDetail(id, fetcher);
  } catch {
    console.error(`Error al prefetch SIFCOP detail para id ${id}`);
  }
};

export const sifcopDetailCacheConfig = {
  ttlMs: CACHE_TTL_MS,
  maxItems: CACHE_MAX_ITEMS,
};
